module.exports = __webpack_public_path__ + "static/media/bz.64d617ea.svg";